import { Component, ViewChild } from "@angular/core";
import { DxChartComponent, DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { GlobalHycoAwardsService } from "./h2-global-hyco-awards.service";
import query from "devextreme/data/query";

@Component({
    selector: 'GlobalHycoAwards',
    templateUrl: './h2-global-hyco-awards.component.html',
    styleUrls: ['./h2-global-hyco-awards.component.scss']
})

export class H2GlobalHycoAwardsComponent {

    isLoadPanelVisible: boolean = false;
    globalHycoAwardsReportData: any;
    hycoAnalysisData: any;
    readonly allowedPageSizes = [50, 100, 200];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @ViewChild(DxChartComponent) chart: DxChartComponent;

    constructor(private notificationService: NotificationService, private globalHycoAwardsService: GlobalHycoAwardsService) {
        this.getGlobalHycoAwardsReport();
    }

    getGlobalHycoAwardsReport() {
        this.isLoadPanelVisible = true;
        this.globalHycoAwardsService.getGlobalHycoAwardsReport().subscribe({
            next: globalASUForecastReportData => {
                this.globalHycoAwardsReportData = globalASUForecastReportData;
                this.hycoAnalysisData = this.getChartDataSource(globalASUForecastReportData);
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching GlobalASUForecastReport data", error);
            }
        });
    }

    getChartDataSource(globalASUForecastReportData) {
        var result = [];
        globalASUForecastReportData.reduce(function (res, value) {
            if (!res[value.hycoCategory]) {
                res[value.hycoCategory] = { hycoCategory: value.hycoCategory, totalHyCOMMSCFD: 0 };
                result.push(res[value.hycoCategory])
            }
            res[value.hycoCategory].totalHyCOMMSCFD += value.totalHycoMMSCFD;
            return res;
        }, {});
        return result;
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    onOptionChanged(e) {
        if (e.fullName.indexOf("filterValue") > -1) {
            setTimeout(() => {
                var filterExpr = e.component.getCombinedFilter(true);

                if (filterExpr) {
                    this.hycoAnalysisData = this.getChartDataSource(query(this.globalHycoAwardsReportData)
                        .filter(filterExpr)
                        .toArray());
                } else {
                    this.hycoAnalysisData = this.getChartDataSource(this.globalHycoAwardsReportData);
                }
            });
        }
    }

    exportExcel(e) {
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'GlobalHYCOAwardsReportData.xlsx');
                });
        }).then(() => {
            this.dataGrid.instance.columnOption('siteId', 'visible', false);
        });
        e.cancel = true;
    }
}